export default __webpack_public_path__ + "static/media/project8.13363454.png";